import React from 'react';
import MovieDetails from '../Components/MovieDetails'
import Subscribe from '../Components/Subscribe';

const SingleMovie = () => {
  return (
    <>
      <MovieDetails />
      <Subscribe />
    </>
  )
}

export default SingleMovie;